export const playerSocketSetting = {
    master_toggle_play_song_user: function (data) {
        this.$store.commit('player/toggleQuizIsPlaySongUser', data)
    },

    master_update_play_setting: function (data) {
        this.$store.commit('player/toggleQuizPlayerSound', data.player_sound)
        this.$store.commit('player/updateDelayAnswer', data.delay_answer)
        this.$store.commit('player/updateDelayQuestion', data.delay_question)
        this.$store.commit('player/updateTimeLimit', data.time_limit)
        this.$store.commit('player/updateProgressBarStatus', data.progress_bar_status)
    }
}